import type { UserInfo } from '../../types/UserInfo.d.ts';
import { distinct } from '../immutable/array/distinct.ts';

/**
 * Flattens the permissions into an easy-to-search array.
 * @param userInfo
 * @param organizationSlug Optional, the organizationSlug to include permissions from.
 *  If omitted, permissions from all organizations are returned.
 * @return An array of all permissions
 */
export function flattenPermissions(userInfo: UserInfo, organizationSlug?: string) {
  return distinct(
    (organizationSlug
      ? (userInfo.organizations.find(({ slug }) => slug === organizationSlug)?.products ?? [])
      : userInfo.organizations.flatMap(({ products }) => products)
    ).flatMap(({ roles }) =>
      roles.flatMap(({ permissions }) =>
        permissions.flatMap(({ id }) => id)
      )
    )
  );
}